/*
 * Site: {SITE}
 * File: custom/modal
 * ============================================================================
 * Some description...
 * ============================================================================
 * Built by Xanthe Studios | xanthestudios.co.uk
 * ============================================================================
 */

/**
 * Some description...
 */

$('.js-open-modal').on('click', function () {

	// Toggle classes
	$('#' + $(this).data('modal')).toggleClass('is-open');

});





/**
 * Some description...
 */

$('.js-close-modal').on('click', function () {

	// Toggle classes
	$(this).parent().parent().toggleClass('is-open');

});


$(document).keyup(function(e) {

	if ((e.keyCode === 27) && ($('.c-modal').hasClass('is-open'))) {            // Escape key

		// Toggle classes
		$('.c-modal').removeClass('is-open');

	}

});
